module.exports = __webpack_public_path__ + "static/media/forms.8df19ec3.png";